import React, { useCallback, useEffect, useState } from "react";
import styles from "./PayContent.module.scss";
import { Button, Space } from "antd-mobile";
import http from "../../http";
import wx from "weixin-js-sdk";
import { ShowMessage } from "../ShowMessage/ShowMessage";
import SHA1 from "crypto-js/sha1";
import { isWeChatBrowser } from "../../utils/util";
import { productType } from "../../pages";

export default function PayContent(props: {
  productList: Array<productType>;
  ticket: string;
  paySuccess: () => void;
}) {
  const { productList, ticket, paySuccess } = props;
  const [payLoading, setPayLoading] = useState(false);
  const [activeItem, setActiveItem] = useState<productType>();

  const bindCard = () => {
    setPayLoading(true);
    let data = {
      product_id: activeItem?.uuid,
      pay_type: isWeChatBrowser() ? "weixin_jsapi" : "weixin_h5",
    };
    http
      .post("/api/v1/payment/pay", data)
      .then((res: any) => {
        if (res.status) {
          if (isWeChatBrowser()) {
            wxPay(res.data);
            setPayLoading(false);
          } else {
            var mweb_url = res.data;
            // 跳转到微信支付页面
            window.location.href = mweb_url;
          }
        } else {
          ShowMessage.error(res.message);
          setPayLoading(false);
        }
      })
      .catch(() => {
        setPayLoading(false);
      });
  };
  const wxPay = useCallback(
    (data: any) => {
      const { appId, nonceStr, paySign, signType, timeStamp } = data;
      const jsapi_ticket = `${ticket}&noncestr=${nonceStr}&timestamp=${timeStamp}&url=${location.href}`;
      // Step 2: Sign the string using SHA1
      const signature = SHA1(jsapi_ticket).toString();
      // 初始化微信JS-SDK
      wx.config({
        debug: false, // 开启调试模式
        appId: appId,
        timestamp: timeStamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: [
          "chooseWXPay",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
        ], // 需要使用的JS接口列表
      });
      wx.chooseWXPay({
        timestamp: timeStamp,
        nonceStr: nonceStr,
        package: data.package,
        signType: signType,
        paySign: paySign,
        success: function (result: any) {
          // 支付成功后的回调函数
          paySuccess();
          setPayLoading(false);
          alert("支付成功");
        },
        fail: function (err) {
          console.log(err);
          setPayLoading(false);
          // 支付失败后的回调函数
          alert("支付失败");
        },
      });
    },
    [ticket]
  );

  return (
    <div className={styles.payContent}>
      <p className={styles.prompt}>
        您今日免费回答次数已达到上限10次， <br />
        请明日再次使用
        <br />
        或者点击下方进行会员升级
      </p>
      <div className={styles.payBox}>
        <Space direction="vertical" className={styles.amountBox}>
          {productList.map((item, index) => {
            return item.is_buy ? (
              <div
                className={`${styles.item} ${
                  item.uuid === activeItem?.uuid ? styles.activeItem : ""
                }`}
                key={item.uuid}
                onClick={() => {
                  setActiveItem(item);
                }}
              >
                <div className={styles.text}>{item.description}</div>
                {item.discount_price && (
                  <del className={styles.price} style={{ marginRight: 5 }}>
                    {item.price}
                  </del>
                )}
                <div className={styles.price}>
                  {item.discount_price || item.price}元
                </div>
              </div>
            ) : null;
          })}
        </Space>
      </div>
      <Button
        block
        shape="rounded"
        loading={payLoading}
        color="primary"
        onClick={bindCard}
        disabled={!activeItem?.uuid}
      >
        支付
      </Button>
    </div>
  );
}
